<template>
  <div class="relative w-full h-screen overflow-hidden bg-[hsl(var(--hue),100%,5%)] opacity-80 animate-fade">
    <div class="lights">
      <div v-for="light in lights" :key="light.id" class="light" :style="lightStyle(light)"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const LIGHT_COUNT = 30;

const randomInRange = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

const hues = ref(new Array(3).fill().map(() => randomInRange(70, 300)));
const alphas = ref(new Array(3).fill().map(() => Math.random()));

const lights = ref([]);

onMounted(() => {
  lights.value = Array.from({ length: LIGHT_COUNT }, (_, id) => ({
    id,
    duration: randomInRange(5, 15),
    delay: randomInRange(4, 10),
    x: randomInRange(0, 5),
    y: randomInRange(0, 10),
    scale: Math.random() / 10,
  }));
});

const lightStyle = (light) => ({
  '--duration': `${light.duration}s`,
  '--delay': `${light.delay}s`,
  '--x': light.x,
  '--y': light.y,
  '--scale': light.scale,
});
</script>

<style scoped>
:root {
  --hue: 220;
}

.lights {
  @apply absolute left-1/2 top-0 flex h-[100vmax] w-[200vmax] blur-[75px];
  transform: translate(-20%, -55%) rotate(30deg);
  opacity: 25%;
}

.light {
  flex: 1;
  --color-one: hsla(v-bind('hues[0]'), 100%, 50%, v-bind('alphas[0]'));
  --color-two: hsla(v-bind('hues[1]'), 100%, 50%, v-bind('alphas[1]'));
  --color-three: hsla(v-bind('hues[2]'), 100%, 50%, v-bind('alphas[2]'));
  --up: calc(var(--y, 10) * 2vmax);
  --left: calc(var(--x, 2) * 2vmax);
  background-image: linear-gradient(0deg, transparent, var(--color-one) 10%, transparent, var(--color-two) 40%, transparent, var(--color-three) 60%);
  background-size: 100% 40vmax;
  background-position: center bottom;
  background-repeat: no-repeat;
  transform: translate(var(--left), var(--up)) scale(1);
  animation: shift calc(var(--duration, 2) * 1s) calc(var(--delay, 0) * -1s) infinite ease;
}

@keyframes shift {
  50% {
    transform: translate(0, 0) scale(1);
  }
}

@media (max-width: 768px) {
  .light {
    --up: calc(var(--y, 10) * 2vmax);
    --left: calc(var(--x, 2) * 2vmax);
  }
}
</style>